// settings actions
export const CONNECT_BTN_CLICKED = 'CONNECT_BTN_CLICKED';
export const DISCONNECT_BTN_CLICKED = 'DISCONNECT_BTN_CLICKED';
export const SET_COMP_ID = 'SET_COMP_ID';
export const CONNECT_ERROR = 'CONNECT_ERROR';
export const ADD_EVENT_COLOR = 'ADD_EVENT_COLOR';
export const HANDLE_MONTH_CHANGE = 'HANDLE_MONTH_CHANGE';
export const SET_IS_ALL_CALENDARS_UNCHECKED = 'SET_IS_ALL_CALENDARS_UNCHECKED';
export const ON_SETTINGS_LOAD = 'ON_SETTINGS_LOAD';
export const HANDLE_TIMEZONE_CHANGE = 'HANDLE_TIMEZONE_CHANGE';
export const UPDATE_ISDEMOSSR = 'UPDATE_ISDEMOSSR';
export const IS_DATES_RETURN = 'IS_DATES_RETURN';
export const REFRESH_DATA = 'REFRESH_DATA';
export const GET_RECURRENCE_BY_RECURRENCEID = 'GET_RECURRENCE_BY_RECURRENCEID';
export const UPDATE_EVENTS_FOR_CALENDAR_SELECTED =
  'UPDATE_EVENTS_FOR_CALENDAR_SELECTED';

export const UPDATE_CALENDAR_SELECTED = 'UPDATE_CALENDAR_SELECTED';
export const UPDATE_MONTH_EXISTS = 'UPDATE_MONTH_EXISTS';
export const IS_LOADED = 'IS_LOADED';
export const IS_SETTINGS_LOADER = 'IS_SETTINGS_LOADER';
export const ON_WIDGET_LOAD = 'ON_WIDGET_LOAD';
export const HANDLE_CONNECT_CLICKED = 'HANDLE_CONNECT_CLICKED';

export const UPDATE_CALENDAR_LIST = 'UPDATE_CALENDAR_LIST';
